import React from 'react';
import { Link } from 'react-router-dom';
import './KrishparStaffing.css';

const KrishparStaffing = () => {
  return (
    <div className="krishpar-staffing-page">
      {/* HERO SECTION */}
      <section className="ks-hero">
        <div className="ks-hero-content">
          <div className="hero-label animate delay-1">
            {/* <span></span> */}
            General Staffing &amp; Recruitment
          </div>
          <h1 className="ks-hero-title animate delay-2">
            The Right <em className="highlight">People</em>,<br />At Every Stage.
          </h1>
          <p className="hero-sub animate delay-3">
            From first interview to final farewell, Krishpar Technologies manages the complete employee lifecycle — so your organisation is always powered by its best people.
          </p>
          <div className="ks-hero-actions animate delay-4">
            <a href="#services" className="btn-primary">
              Explore Our Services
              <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
            </a>
            <a href="#lifecycle" className="btn-outline">See the Journey</a>
          </div>
        </div>

        {/* Hero SVG illustration */}
        <div className="hero-visual">
          <svg viewBox="0 0 440 420" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Background circles */}
            <circle cx="220" cy="210" r="180" stroke="rgba(255,255,255,0.04)" strokeWidth="1" />
            <circle cx="220" cy="210" r="130" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
            <circle cx="220" cy="210" r="80" fill="rgba(125,194,66,0.12)" />

            {/* Center person icon */}
            <circle cx="220" cy="185" r="38" fill="#7DC242" opacity="0.9" />
            <circle cx="220" cy="170" r="16" fill="white" />
            <path d="M188 218c0-17.7 14.3-32 32-32s32 14.3 32 32" fill="white" />

            {/* Orbit nodes */}
            {/* Attract */}
            <circle cx="220" cy="48" r="28" fill="#1A3B8C" />
            <text x="220" y="52" textAnchor="middle" fill="white" fontSize="11" fontFamily="Syne" fontWeight="700">ATTRACT</text>
            {/* Select */}
            <circle cx="356" cy="128" r="28" fill="#2B50B8" />
            <text x="356" y="132" textAnchor="middle" fill="white" fontSize="11" fontFamily="Syne" fontWeight="700">SELECT</text>
            {/* Onboard */}
            <circle cx="380" cy="270" r="28" fill="#1A3B8C" />
            <text x="380" y="274" textAnchor="middle" fill="white" fontSize="11" fontFamily="Syne" fontWeight="700">ONBOARD</text>
            {/* Develop */}
            <circle cx="260" cy="370" r="28" fill="#7DC242" />
            <text x="260" y="374" textAnchor="middle" fill="#0D1B4B" fontSize="11" fontFamily="Syne" fontWeight="700">GROW</text>
            {/* Retain */}
            <circle cx="130" cy="355" r="28" fill="#2B50B8" />
            <text x="130" y="359" textAnchor="middle" fill="white" fontSize="11" fontFamily="Syne" fontWeight="700">RETAIN</text>
            {/* Exit */}
            <circle cx="72" cy="220" r="28" fill="#1A3B8C" />
            <text x="72" y="224" textAnchor="middle" fill="white" fontSize="11" fontFamily="Syne" fontWeight="700">OFFBOARD</text>

            {/* Connecting lines */}
            <line x1="220" y1="76" x2="220" y2="130" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" strokeDasharray="4 4" />
            <line x1="330" y1="140" x2="258" y2="188" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" strokeDasharray="4 4" />
            <line x1="356" y1="244" x2="260" y2="218" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" strokeDasharray="4 4" />
            <line x1="240" y1="342" x2="228" y2="250" stroke="rgba(125,194,66,0.3)" strokeWidth="1.5" strokeDasharray="4 4" />
            <line x1="148" y1="336" x2="212" y2="242" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" strokeDasharray="4 4" />
            <line x1="96" y1="215" x2="182" y2="208" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" strokeDasharray="4 4" />
          </svg>
        </div>
      </section>

      {/* LIFECYCLE STRIP */}
      {/* <div className="lifecycle-strip">
        <div className="lifecycle-inner">
          <div className="step">Attract</div>
          <div className="arrow">›</div>
          <div className="step">Screen</div>
          <div className="arrow">›</div>
          <div className="step">Select</div>
          <div className="arrow">›</div>
          <div className="step">Onboard</div>
          <div className="arrow">›</div>
          <div className="step">Develop</div>
          <div className="arrow">›</div>
          <div className="step">Retain</div>
          <div className="arrow">›</div>
          <div className="step">Transition</div>
        </div>
      </div> */}

      {/* WHAT WE DO SECTION */}
      <section className="intro-section fade-in">
        <div className="intro-text">
          <p className="section-tag">Who We Are</p>
          <h2 className="section-title">More than a <span>recruitment</span> agency.</h2>
          <p className="section-lead">
            Krishpar Technologies is a full-spectrum workforce partner. We don&apos;t just fill vacancies — we align people, purpose, and performance. Whether you need to scale fast, find a niche specialist, or build long-term workforce stability, we&apos;re the engine behind your people strategy.
          </p>
          <ul className="why-list" style={{ marginTop: '32px' }}>
            <li>Dedicated talent advisors who understand your industry deeply</li>
            <li>End-to-end management from sourcing to separation</li>
            <li>Transparent, speed-first recruitment without compromising quality</li>
            <li>Compliant HR practices covering all regulatory requirements</li>
          </ul>
        </div>
        <div className="intro-graphic">
          <div className="big-circle">
            <div className="big-circle-inner">
              <div className="num">360°</div>
              <div className="num-label">Employee<br />Lifecycle<br />Coverage</div>
            </div>
            <div className="orbit-badge ob1">Talent Sourcing</div>
            <div className="orbit-badge ob2">Payroll & Compliance</div>
            <div className="orbit-badge ob3">Performance Mgmt</div>
          </div>
        </div>
      </section>

      {/* LIFECYCLE JOURNEY SECTION */}
      <section className="lifecycle-section fade-in" id="lifecycle">
        <div className="lifecycle-header">
          <div>
            <p className="section-tag">The Employee Journey</p>
            <h2 className="section-title">Every step, <span style={{ color: 'var(--green)' }}>covered.</span></h2>
          </div>
          <p className="section-lead" style={{ maxWidth: '340px' }}>
            From the moment a candidate discovers your brand to the day they retire or move on — Krishpar is with you at every milestone.
          </p>
        </div>

        <div className="journey-track">

          <div className="journey-step">
            <div className="journey-icon">
              <div className="step-num">1</div>
              <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></svg>
            </div>
            <div className="journey-title">Attract &amp; Source</div>
            <div className="journey-desc">Job architecture, employer branding, multi-channel talent sourcing and job posting strategy.</div>
          </div>

          <div className="journey-step">
            <div className="journey-icon">
              <div className="step-num">2</div>
              <svg viewBox="0 0 24 24"><path d="M9 12l2 2 4-4" /><rect x="3" y="3" width="18" height="18" rx="2" /></svg>
            </div>
            <div className="journey-title">Screen &amp; Assess</div>
            <div className="journey-desc">Resume shortlisting, skill assessments, background checks and cultural-fit evaluation.</div>
          </div>

          <div className="journey-step">
            <div className="journey-icon">
              <div className="step-num">3</div>
              <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
            </div>
            <div className="journey-title">Interview &amp; Select</div>
            <div className="journey-desc">Structured interviews, panel co-ordination, offer management and negotiation support.</div>
          </div>

          <div className="journey-step">
            <div className="journey-icon">
              <div className="step-num">4</div>
              <svg viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
            </div>
            <div className="journey-title">Onboard &amp; Induct</div>
            <div className="journey-desc">Paperwork, induction plans, first-week check-ins and role clarity sessions for new joiners.</div>
          </div>

          <div className="journey-step">
            <div className="journey-icon">
              <div className="step-num">5</div>
              <svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>
            </div>
            <div className="journey-title">Develop &amp; Retain</div>
            <div className="journey-desc">Performance reviews, L&amp;D co-ordination, career pathing and employee engagement programs.</div>
          </div>

          <div className="journey-step">
            <div className="journey-icon">
              <div className="step-num">6</div>
              <svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" /></svg>
            </div>
            <div className="journey-title">Transition &amp; Exit</div>
            <div className="journey-desc">Exit interviews, knowledge transfer, full-and-final settlements and alumni network management.</div>
          </div>

        </div>
      </section>

      {/* SERVICES SECTION */}
      <section className="services-section fade-in" id="services">
        <div className="services-header">
          <div>
            <p className="section-tag">Our Services</p>
            <h2 className="section-title">What Krishpar <span>does for you</span></h2>
            <p className="section-lead" style={{ maxWidth: '340px' }}>
              A complete toolkit of workforce solutions, shaped around your exact business needs.
            </p>
          </div>
        </div>

        <div className="services-grid">

          <Link to="/krishpar-hiring" className="service-card-link">
            <div className="service-card">
              <div className="service-icon-wrap">
                <svg viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
              </div>
              <div className="service-title">Permanent Placement</div>
              <div className="service-desc">We identify, evaluate and place full-time employees who are not just qualified — but who fit your culture and grow with your organisation for the long haul.</div>
            </div>
          </Link>

          <Link to="/it-staffing-contracts" className="service-card-link">
            <div className="service-card featured">
              <div className="service-icon-wrap">
                <svg viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>
              </div>
              <div className="service-title">Contract &amp; Temporary Staffing</div>
              <div className="service-desc">Scale your workforce up or down with pre-vetted contract professionals for project peaks, seasonal demand, or specialised short-term assignments. Flexible, fast, reliable.</div>
            </div>
          </Link>

          <Link to="/krishpar-hiring" className="service-card-link">
            <div className="service-card">
              <div className="service-icon-wrap">
                <svg viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.08 13.18 19.79 19.79 0 0 1 1 4.59 2 2 0 0 1 2.96 2.4h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16.92z" /></svg>
              </div>
              <div className="service-title">Executive Search</div>
              <div className="service-desc">Confidential search for C-suite, director and senior leadership roles. We leverage deep networks to find visionary leaders who drive real business transformation.</div>
            </div>
          </Link>

          <div className="service-card">
            <div className="service-icon-wrap">
              <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" /></svg>
            </div>
            <div className="service-title">HR Outsourcing &amp; Compliance</div>
            <div className="service-desc">End-to-end HR administration, statutory compliance, payroll processing and labour law advisory — freeing your team to focus on strategic priorities.</div>
          </div>

          <Link to="/krishpar-hiring" className="service-card-link">
            <div className="service-card">
              <div className="service-icon-wrap">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
              </div>
              <div className="service-title">RPO — Recruitment Process Outsourcing</div>
              <div className="service-desc">We embed our team into your hiring function, taking full ownership of the recruitment pipeline — from workforce planning right through to the offer letter.</div>
            </div>
          </Link>

          <div className="service-card">
            <div className="service-icon-wrap">
              <svg viewBox="0 0 24 24"><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" /></svg>
            </div>
            <div className="service-title">Onboarding &amp; Exit Management</div>
            <div className="service-desc">Structured onboarding that gets new hires productive in days, and humane exit processes that protect your employer brand and retain institutional knowledge.</div>
          </div>

        </div>
      </section>

      {/* WHY KRISHPAR SECTION */}
      <section className="ks-why-section fade-in">
        <div className="why-content">
          <p className="section-tag" >Why Us</p>
          <h2 className="section-title" >Striving <span>Par Excellence</span> — always.</h2>
          <p className="section-lead" >
            Our tagline is not a slogan. It is a commitment we honour in every search, every placement, every relationship. Here is what sets Krishpar apart.
          </p>
          <ul className="why-list">
            <li>Speed without compromise — average time-to-shortlist in 48 hours</li>
            <li>Industry-vertical specialists, not generalist recruiters</li>
            <li>Single point of contact for the full lifecycle, no handovers</li>
            <li>Data-driven sourcing with human-led relationship management</li>
            <li>Post-placement support for 90 days as standard</li>
            <li>Complete confidentiality at every stage of engagement</li>
          </ul>
        </div>
        <div className="ks-why-visual">
          <div className="why-card">
            <div className="why-metric">48<span>hr</span></div>
            <div className="why-metric-label">Avg. Time to Shortlist</div>
          </div>
          <div className="why-card">
            <div className="why-metric">95<span>%</span></div>
            <div className="why-metric-label">Client Retention Rate</div>
          </div>
          <div className="why-card">
            <div className="why-metric">360<span>°</span></div>
            <div className="why-metric-label">Employee Lifecycle Cover</div>
          </div>
          <div className="why-card">
            <div className="why-metric">90<span>d</span></div>
            <div className="why-metric-label">Post-Placement Support</div>
          </div>
        </div>
      </section>

      {/* INDUSTRIES SECTION */}
      <section className="industries-section fade-in">
        <div className="industries-header">
          <p className="section-tag">Sectors We Serve</p>
          <h2 className="section-title">Cross-industry <span>expertise</span></h2>
          <p className="section-lead" style={{ textAlign: 'start' }}>
            Deep domain knowledge across verticals means we understand not just your hiring need, but your business context.
          </p>
        </div>
        <div className="industries-scroll">
          <div className="industry-pill">
            <span className="industry-emoji">🏭</span>
            <div className="industry-name">Manufacturing &amp;<br />Engineering</div>
          </div>
          <div className="industry-pill">
            <span className="industry-emoji">💻</span>
            <div className="industry-name">Information<br />Technology</div>
          </div>
          <div className="industry-pill">
            <span className="industry-emoji">🏥</span>
            <div className="industry-name">Healthcare &amp;<br />Pharma</div>
          </div>
          <div className="industry-pill">
            <span className="industry-emoji">🏗️</span>
            <div className="industry-name">Construction &amp;<br />Infrastructure</div>
          </div>
          <div className="industry-pill">
            <span className="industry-emoji">🛒</span>
            <div className="industry-name">Retail &amp;<br />FMCG</div>
          </div>
          <div className="industry-pill">
            <span className="industry-emoji">🏦</span>
            <div className="industry-name">Banking, Finance<br />&amp; Insurance</div>
          </div>
          <div className="industry-pill">
            <span className="industry-emoji">📦</span>
            <div className="industry-name">Logistics &amp;<br />Supply Chain</div>
          </div>
          <div className="industry-pill">
            <span className="industry-emoji">🎓</span>
            <div className="industry-name">Education &amp;<br />EdTech</div>
          </div>
        </div>
      </section>

      {/* PROCESS SECTION */}
      <section className="process-section fade-in">
        <div className="process-header">
          <p className="section-tag">How We Work</p>
          <h2 className="section-title" style={{ color: 'var(--white' }}>Our recruitment <span style={{ color: 'var(--green)' }}>process</span></h2>
        </div>
        <div className="process-grid">
          <div className="process-item">
            <div className="process-num">01</div>
            <div>
              <div className="process-title">Discovery &amp; Brief</div>
              <div className="process-desc">We start with a deep-dive into your organisation — culture, role scope, team dynamics and success metrics. No template briefs, only bespoke understanding.</div>
            </div>
          </div>
          <div className="process-item">
            <div className="process-num">02</div>
            <div>
              <div className="process-title">Market Mapping &amp; Sourcing</div>
              <div className="process-desc">Leveraging our proprietary database, job boards, referral networks and headhunting, we cast the widest — and most targeted — net for your ideal candidate.</div>
            </div>
          </div>
          <div className="process-item">
            <div className="process-num">03</div>
            <div>
              <div className="process-title">Rigorous Screening</div>
              <div className="process-desc">Multi-stage assessment: technical competency, behavioural interviews, reference checks and background verification — before a single CV reaches your desk.</div>
            </div>
          </div>
          <div className="process-item">
            <div className="process-num">04</div>
            <div>
              <div className="process-title">Curated Shortlist</div>
              <div className="process-desc">You receive a focused shortlist of 3–5 fully assessed candidates with detailed profiles, not a pile of CVs. Every profile comes with our advisor&apos;s recommendation note.</div>
            </div>
          </div>
          <div className="process-item">
            <div className="process-num">05</div>
            <div>
              <div className="process-title">Interview Co-ordination</div>
              <div className="process-desc">We manage scheduling, brief candidates, collect feedback loops and keep the process moving — so the right hire never falls through due to slow communication.</div>
            </div>
          </div>
          <div className="process-item">
            <div className="process-num">06</div>
            <div>
              <div className="process-title">Offer, Onboard &amp; Beyond</div>
              <div className="process-desc">Offer letter management, pre-joining engagement, onboarding support and a 90-day post-placement check to ensure lasting success — for employer and employee alike.</div>
            </div>
          </div>
        </div>
      </section>

      {/* PROMISE BAND */}
      <section className="promise-band fade-in" id="connect">
        <h2>Your next great hire is closer than you think.</h2>
        <p>
          Tell us what you need. Krishpar Technologies will handle everything else — with speed, precision, and the dedication that comes with striving par excellence.
        </p>
        <a href="mailto:connect@krishpar.com" className="btn-dark">
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
          Start a Conversation
        </a>
      </section>

    </div>
  );
};

export default KrishparStaffing;
